var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Liens")]),_c('ul',_vm._l((_vm.liens),function(lien){return _c('li',{staticStyle:{"margin-bottom":"10px"}},[_c('a',{attrs:{"target":"blank","href":lien.href}},[_vm._v(_vm._s(lien.text))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }